import {needAuth} from "../instance/Instance";
import {AxiosError} from "axios";

async function getWorkList(search, pageable) {
    console.log(">> 작업관리 List 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return  await needAuth.post(`/maintenance/work?`+pageStr,search);
    }catch (error){
        return error;
    }
}

async function removeWorks(ids) {
    return await needAuth.put('/maintenance/work/delete', ids);
}

async function getWork(id) {
    return await needAuth.get('/maintenance/work/'+id);
}

async function saveWork(work, assets, handler, files) {
    const formData = new FormData();
    files.forEach((file, index) => {
        formData.append(`files`, file);
    });

    const assetData = assets?.map(item => ({id : item.id}));
    work.assetIds = assetData;

    const handlerIds = handler?.map(item => (item.id));
    work.handlerIds = handlerIds;

    formData.append(
        "workRequestDto",
        new Blob([JSON.stringify(work)], { type: "application/json" })
    );

    try{
        return await needAuth.post(`/maintenance/work/create`, formData, {headers : {'Content-Type': 'multipart/form-data'}});
    }catch (error){
        return error;
    }
}

async function updateWork(work, assets, handler) {
    const assetData = assets?.map(item => ({id : item.id}));
    work.assetIds = assetData;

    const handlerIds = handler?.map(item => (item.id));
    work.handlerIds = handlerIds;

    try {
        return await needAuth.post(`/maintenance/work/update`, work);
    }catch (error){
        return error
    }
}

const updateWorkForInProgress = async (data, files) => {
    const formData = new FormData();
    files.forEach((file, index) => {formData.append(`files`, file.object);});
    formData.append("requestDto", new Blob([JSON.stringify(data)], { type: "application/json" }));

    try {
        return await needAuth.put(
            `/maintenance/work/inProgress`, formData,
            {headers: {'Content-Type': 'multipart/form-data'}}
        )
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const updateWorkForVerification = async (data) => {
    try {
        return await needAuth.put(`/maintenance/work/verification`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

async function removeWorkPlan(id) {
    try {
        return await needAuth.put('/maintenance/work/plan/delete', id);
    }catch (error){
        return error
    }
}

async function getWorkPlan(id) {
    try {
        return await needAuth.get('/maintenance/work/plan/'+id);
    }catch (error){
        return error
    }
}

async function saveWorkPlan(workPlan, files) {
    const formData = new FormData();
    files.forEach((file, index) => {
        formData.append(`files`, file);
    });

    formData.append(
        "workPlanRequestDto",
        new Blob([JSON.stringify(workPlan)], { type: "application/json" })
    );

    try{
        return await needAuth.post(`/maintenance/work/plan/create`, formData, {headers : {'Content-Type': 'multipart/form-data'}});
    }catch (error){
        return error
    }
}

async function updateWorkPlan(work) {
    try {
        return await needAuth.post(`/maintenance/work/plan/update`, work);
    }catch (error){
        return error
    }
}

async function removeWorkResult(id) {
    try {
        return await needAuth.put('/maintenance/work/result/delete', id);
    }catch (error){
        return error
    }
}

async function getWorkResult(id) {
    try {
        return await needAuth.get('/maintenance/work/result/'+id);
    }catch (error){
        return error
    }
}

async function saveWorkResult(workResult, files) {
    const formData = new FormData();
    files.forEach((file, index) => {
        formData.append(`files`, file);
    });

    formData.append(
        "workResultRequestDto",
        new Blob([JSON.stringify(workResult)], { type: "application/json" })
    );

    return await needAuth.post(`/maintenance/work/result/create`, formData, {headers : {'Content-Type': 'multipart/form-data'}});
}

async function updateWorkResult(work) {
    try {
        return await needAuth.post(`/maintenance/work/result/update`, work);
    }catch (error){
        return error;
    }
}

export {
    getWorkList,
    removeWorks,
    saveWork,
    getWork,
    updateWork,
    updateWorkForInProgress,
    updateWorkForVerification,
    removeWorkPlan,
    removeWorkResult,
    saveWorkResult,
    saveWorkPlan,
    updateWorkPlan,
    updateWorkResult,
    getWorkResult,
    getWorkPlan
}